/*
 * @Author: wangshengqiang
 * @Date: 2021-04-19 17:02:24
 * @LastEditTime: 2022-02-28 13:56:35
 * @LastEditors: wangshengqiang
 * @Description: 基础组件
 */
export { default as BaseFormItem } from './FormItem';
export { default as BaseRemark } from './Remark';
export { default as DateSelect } from './DateSelect';
export { default as Select } from './Select';
export { default as FormItem } from './FormItem';
export { default as Iconfont } from './Iconfont';
export { default as CertValidity } from './CertValidity';
export { default as SignArea } from './SignArea';
export { default as FileUpload } from './FileUpload';
export { default as VerifyCode } from './VerifyCode';